import React from "react";
import { Mail, ArrowUpRight } from "lucide-react";

export default function ContactSection() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="py-24 md:py-32 relative"
    >
      {/* Background accent */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#1a2f2a]/10 to-transparent pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl">
          {/* Section label */}
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-[#34D399]/80 mb-4 block">
            // Let's Connect
          </span>

          <h2
            data-testid="contact-heading"
            className="text-3xl md:text-5xl font-semibold tracking-tight text-[#F0FDF4] mb-6"
          >
            Ready to Explore
            <br />
            the Quantum Edge?
          </h2>

          <p className="text-base md:text-lg text-[#94A3B8] leading-relaxed mb-10">
            Whether you're looking to integrate quantum-enhanced algorithms 
            into your financial models or need strategic guidance on 
            quantum computing adoption&mdash;let's start a conversation.
          </p>

          {/* CTA Button */}
          <a
            href="mailto:javier@cybersyn.systems?subject=Consultation%20Request"
            data-testid="contact-email-link"
            className="group inline-flex items-center gap-3 bg-[#34D399] text-[#064E3B] font-semibold text-lg px-10 py-5 rounded-full cta-glow hover:bg-[#10B981] transition-all"
          >
            <Mail size={20} />
            Schedule a Consultation
            <ArrowUpRight
              size={18}
              className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1"
            />
          </a>

          <p className="mt-6 text-[#94A3B8] font-mono text-sm">
            javier@cybersyn.systems
          </p>
        </div>
      </div>
    </section>
  );
}
